<template>
  <div>
    <header-sales></header-sales>


    <!-- pc view -->
    <div v-if='!mobileView'> 
        <div  id="headerImageContainer" >
          <img id="headerImage" :src="imageHeader" style="height: 150px;">
        </div>
        <div id="mainContainer" style="overflow: auto;">
            <div>
                <span id="labelEstado" class="tituloSeccion">Cuenta Corriente:</span> 
                <span id="labelCtaCte">${{saldoCtaCte | formatMoney}}</span> 
                <span class="verTodos" @click="btnCtaCte">Ver</span>
            </div>
            <div style="margin-bottom: 10px; margin-top: 20px">
                <span   id="labelEstado" class="tituloSeccion">Pedidos</span>
                <span  class="verTodos" @click="btnVerEstadoPedidos" >Ver Todos</span>
            </div>
            <div class="fh cc">
                <div class="oblea-NuevoPedido" @click="btnNuevoPedido">
                    <img id="icon-add" style="width: 30px; height: 30px" src="/dist/icon-add.png" >
                    <p id="label-realizarPedido">Nuevo Pedido</p>
                </div>
                <item-pedido-home v-for="item in itemsPedido" :item='item'></item-pedido-home>
            </div>
            <div id="promoDescLabelContainer">
                <div id="promoLabelContainer" style="margin-top: 20px; margin-bottom: 10px;  width: 425px" v-show='showItemsPromo' >
                    <span class="tituloSeccion">Combos</span>
                    <span class="verTodos" @click="btnVerPromociones" >Ver Todos</span>
                </div>


                <div id="descLabelContainer" style="margin-top: 20px;margin-bottom: 10px;" v-show='showItemsDescuento' >
                    <span class="tituloSeccion">Descuentos</span>
                    <span class="verTodos" @click="btnVerDescuentos" >Ver Todos</span>
                </div>


            </div>
            <div id="promoDescContainer" >
                <div id="promoContainer" v-show='showItemsPromo' style="width:425px; height: 150px; margin-right: 0px">
                    <item-promocion v-for="item in itemsPromo " :item='item'></item-promocion>
                </div>
        
        
                <div @click="btnVerDescuentos" v-show='showItemsDescuento'>
                    <item-descuento v-for="item in itemsDescuento " :item='item'></item-descuento>
                </div>

                
            </div>
            <!-- nuevo -->
            <div v-show="showPresupuestos" style="margin-bottom: 10px; margin-top: 20px">
                <span   id="labelEstado" class="tituloSeccion">Presupuestos</span>
                <span  class="verTodos" @click="btnVerPresupuestos" >Ver Todos</span>
            </div>
            <div v-show="showPresupuestos" class="fh cc" style="margin-bottom: 0px">
                <div class="oblea-NuevoPedido" @click="btnNuevoPresupuesto">
                    <img id="icon-add" style="width: 30px; height: 30px" src="/dist/icon-add.png" >
                    <p id="label-realizarPedido">Nuevo Presupuesto</p>
                </div>
                <item-presupuesto-home v-for="item in itemsPresupuesto" :item='item'></item-presupuesto-home>
            </div>
            <div v-show="showDevoluciones" style="margin-bottom: 10px; margin-top: 20px">
                <span   id="labelEstado" class="tituloSeccion">Devoluciones</span>
                <span  class="verTodos" @click="btnVerDevoluciones" >Ver Todos</span>
            </div>
            <div v-show="showDevoluciones" class="fh cc">
                <div class="oblea-NuevoPedido" @click="btnNuevaDevolucion">
                    <img id="icon-add" style="width: 30px; height: 30px" src="/dist/icon-add.png" >
                    <p id="label-realizarPedido">Nueva Devolución</p>
                </div>
                <item-devolucion-home v-for="item in itemsDevolucion" :item='item'></item-devolucion-home>
            </div>
            <!-- nuevo -->
        </div>
    </div>



    <!-- mobile view -->
    <div class='fv lt' style="width: 100vw;" v-if='mobileView'> 
        <div class="fv cc" style="width: 100%; height: 100px; background: linear-gradient(#005A9F , #1899D6); position: fixed;  top: 40px;  width: 100%">
           <img id="headerImage" :src="imageHeader" style="height: 80%;">
        </div>
        <div class="fv lt" style="overflow:auto; margin-top: 140px">
            <div style="margin-top: 20px; margin-left: 30px">
                <span style="font-size: 14px; font-weight: bold; color: black">Cuenta Corriente:</span> 
                <span style="font-size: 14px; font-weight: bold; color: red">${{saldoCtaCte | formatMoney}}</span> 
                <span style="font-size: 11px; font-weight: bold; color: #4969B2" @click="btnCtaCte">Ver</span>
            </div>
            <div style="margin-top: 20px; margin-left: 30px">
                <span style="font-size: 14px; font-weight: bold; color: black">Pedidos</span>
                <span style="font-size: 11px; font-weight: bold; color: #4969B2" @click="btnVerEstadoPedidos">Ver Todos</span>
            </div>
            <div class="fh lt" style="margin-left: 30px; width: 80%; margin-top: 10px;">
                <div class="oblea-NuevoPedido" style="width: 40%; height: 90px;" @click="btnNuevoPedido">
                <img id="icon-add" style="width: 30px; height: 30px" src="/dist/icon-add.png" >
                <p style="font-size: 10px; margin-top: 5px">Nuevo Pedido</p>
                </div>
                <div class="fh lc mobile" style="width: 60%;  overflow: scroll; overflow-y: hidden; ">
                <item-pedido-home   v-for="item in itemsPedido" :item='item'></item-pedido-home>
                </div>
            </div>
            <div style="margin-top: 20px; margin-left: 30px" v-show='showItemsPromo' >
                <span style="font-size: 14px; font-weight: bold; color: black">Combo</span>
                <span style="font-size: 11px; font-weight: bold; color: #4969B2" @click="btnVerPromociones" >Ver Todos</span>
            </div>
            <div class="fh lt" style="margin-top: 10px; margin-left: 30px; width: 80%; overflow-x: auto;" v-show='showItemsPromo'>
                <item-promocion v-for="item in itemsPromo " :item='item'></item-promocion>
            </div>
            <div style="margin-top: 20px; margin-left: 30px" v-show='showItemsDescuento' >
                <span style="font-size: 14px; font-weight: bold; color: black">Descuentos</span>
                <span style="font-size: 11px; font-weight: bold; color: #4969B2" @click="btnVerDescuentos" >Ver Todos</span>
            </div>
            <div class="fh lt" style="margin-top: 10px; margin-left: 30px; width: 80%; overflow-x: auto;" v-show='showItemsDescuento'>
                <item-descuento v-for="item in itemsDescuento " :item='item'></item-descuento>
            </div>
            <!-- nuevo -->
            <div v-show="showPresupuestos" style="margin-top: 20px; margin-left: 30px">
                <span style="font-size: 14px; font-weight: bold; color: black">Presupuestos</span>
                <span style="font-size: 11px; font-weight: bold; color: #4969B2" @click="btnVerPresupuestos">Ver Todos</span>
            </div>
            <div v-show="showPresupuestos" class="fh lt" style="margin-left: 30px; width: 80%; margin-top: 10px;">
                <div class="oblea-NuevoPedido" style="width: 40%; height: 90px;" @click="btnNuevoPresupuesto">
                <img id="icon-add" style="width: 30px; height: 30px" src="/dist/icon-add.png" >
                <p style="font-size: 10px; margin-top: 5px">Nuevo Presupuesto</p>
                </div>
                <div class="fh lc mobile" style="width: 60%;  overflow: scroll; overflow-y: hidden; ">
                <item-presupuesto-home v-for="item in itemsPresupuesto" :item='item'></item-presupuesto-home>
                </div>
            </div>
            <div v-show="showDevoluciones" style="margin-top: 20px; margin-left: 30px">
                <span style="font-size: 14px; font-weight: bold; color: black">Devoluciones</span>
                <span style="font-size: 11px; font-weight: bold; color: #4969B2" @click="btnVerDevoluciones">Ver Todas</span>
            </div>
            <div v-show="showDevoluciones" class="fh lt" style="margin-left: 30px; width: 80%; margin-top: 10px;">
                <div class="oblea-NuevoPedido" style="width: 40%; height: 90px;" @click="btnNuevaDevolucion">
                <img id="icon-add" style="width: 30px; height: 30px" src="/dist/icon-add.png" >
                <p style="font-size: 10px; margin-top: 5px">Nueva Devolución</p>
                </div>
                <div class="fh lc mobile" style="width: 60%;  overflow: scroll; overflow-y: hidden; ">
                <item-devolucion-home  v-for="item in itemsDevolucion" :item='item'></item-devolucion-home>
                </div>
            </div>
            <!-- nuevo -->
        </div>
    </div>
  </div>
</template>


<script>
  import axios from 'axios'
  import HeaderSales from '@components/views/header.vue';
  import ItemPedidoHome from '@components/views/home/itemPedidoHome.vue';
  import ItemPresupuestoHome from '@components/views/home/itemPresupuestoHome.vue';
  import ItemDevolucionHome from '@components/views/home/itemDevolucionHome.vue';
  import ItemPromocion from '@components/views/home/itemPromocionHome.vue';
  import ItemDescuento from '@components/views/home/itemDescuentoHome.vue';

  export default {
    name: 'Lista',

    components:{
     'header-sales': HeaderSales,
     'item-pedido-home': ItemPedidoHome,
     'item-presupuesto-home': ItemPresupuestoHome,
     'item-devolucion-home': ItemDevolucionHome,
     'item-promocion': ItemPromocion,
     'item-descuento': ItemDescuento
    },

      data() {
       return {
        idCategoriasVigentes:[],
        idSubcategoriasVigentes:[],
        mobileView:false
       }
    },


    computed: {

      showPresupuestos() {
        return this.$store.state.user.usuario.PresupuestosHabilitados;
      },

      showDevoluciones() {
        if (this.$store.state.user.usuario.DevolucionesHabilitadas && this.$store.state.user.usuario.EsEmpleado) {
          return true
        }
        else {
          return false
        }
      },

      promociones() {
        return this.$store.state.pedido.promociones;
      },

      itemsPromo () {
        return this.$store.getters['pedido/getPromoHome']
      },

      showItemsPromo () {
        if (this.$store.state.pedido.promociones.length > 0)
        {
          return true
        }
        else
        {
          return false 
        }
      },

      itemsDescuento () {
        return this.$store.getters['pedido/getDescuentosHome']
      },

      showItemsDescuento () {
        if (this.$store.state.pedido.descuentos.length > 0) {
          return true
        }
        else {
          return false 
        }
      },

      itemsPedido () {
        return  this.$store.state.pedido.pedidosHome;
      },

      itemsPresupuesto () {
        return  this.$store.state.pedido.presupuestosHome;
      },

      itemsDevolucion () {
        return  this.$store.state.pedido.devolucionesHome;
      },

      saldoCtaCte(){
        return  this.$store.state.user.ctaCte.SaldoActual
      },

      imageHeader() {
        if (this.$store.state.user.usuario.ArchivoCircuitoUrl != null) {
          return this.$store.state.user.usuario.ArchivoCircuitoUrl
        }
        else {
          return '/dist/logo-header.png'
        }
      } 

    },


    methods: {

      onResize() {
        if (window.innerWidth > 600) 
        {
           this.mobileView=false;
        }
        else 
        {
           this.mobileView=true;
        }
      },

      getPromociones() {
        this.$store.commit('loader/start')
        axios.get(`/WebSalesPromociones?ListaPrecioId=${this.$store.state.user.cliente.ListaPrecioId}&DepositoId=${this.$store.state.user.cliente.DepositoId}`,{
            headers:{
                      Token:        this.$store.state.user.usuario.Token,
                      ClientSecret: this.$store.state.entorno.clientSecret,
                      EmpresaId:    this.$store.state.entorno.idEmpresa
                    }
            }
          ).then((response) => {
              if (response.data.Code == 0) {
                var promos = [];
                response.data.Promociones.forEach((j) => {  
                    if (j.StockDisponible > 0) {
                      promos.push(j) 
                    }
                });  
                this.$store.commit('pedido/savePromociones',promos)
              }
              this.getDescuentos()
          },(error) => {
              this.$store.commit('loader/stop')
              this.$access("any");
              alert(response.data.Message)
              this.$store.commit('user/deleteUser');
              this.$store.commit('user/deleteCliente');
              this.$store.commit('user/deleteEmpresas');
              this.$store.commit('user/deleteResponseLogin');
              this.$store.commit('user/deleteImagenLogo'); 
              this.$store.commit("pedido/delete");
              this.$router.push({name: 'login'});
            })
      },


      getDescuentos() {
        axios.get(`/WebSalesDescuentosv2`,{
            headers:{
                      Token:        this.$store.state.user.usuario.Token,
                      ClientSecret: this.$store.state.entorno.clientSecret,
                      EmpresaId:    this.$store.state.entorno.idEmpresa
                    }
          }
          ).then((response) => {
              if (response.data.Code == 0) {
                this.filtrarDescuentos(response.data.Descuentos)  
              }
             this.getProductos()
          },(error) => {
              this.$store.commit('loader/stop')
              this.$access("any");
              alert(response.data.Message)
              this.$store.commit('user/deleteUser');
              this.$store.commit('user/deleteCliente');
              this.$store.commit('user/deleteEmpresas');
              this.$store.commit('user/deleteResponseLogin');
              this.$store.commit('user/deleteImagenLogo'); 
              this.$store.commit("pedido/delete");
              this.$router.push({name: 'login'});            
            })
      },


      getProductos(idCat,idSubcat) {
        var url = `/WebSalesProductos?ListaPrecioId=${this.$store.state.user.cliente.ListaPrecioId}&DepositoId=${this.$store.state.user.cliente.DepositoId}`;
        axios.get(url,{
         headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                  }
         }
        ).then((response) => {
         if (response.data.Code == 0)
         {
           var prods = []
           response.data.Productos.forEach((j) => {  
            if(j.Precio > 0)
            {
               prods.push(j)
               if (!this.idCategoriasVigentes.includes(j.CategoriaId))
               {
                 this.idCategoriasVigentes.push(j.CategoriaId)
               }
               if (!this.idSubcategoriasVigentes.includes(j.SubCategoriaId))
               {
                 this.idSubcategoriasVigentes.push(j.SubCategoriaId)
               }
            }     
           });  
           this.$store.commit('pedido/saveProductos',prods);
           prods = []
         }
         this.getEstadoPedidos()
      },(error) => {
          this.$store.commit('loader/stop')
          this.$access("any");
          alert(response.data.Message)
          this.$store.commit('user/deleteUser');
          this.$store.commit('user/deleteCliente');
          this.$store.commit('user/deleteEmpresas');
          this.$store.commit('user/deleteResponseLogin');
          this.$store.commit('user/deleteImagenLogo'); 
          this.$store.commit("pedido/delete");
          this.$router.push({name: 'login'});        
        })
      },    


      getEstadoPedidos () {
        this.pedidoRequest = {
        'FechaDesde': "10/01/2010",
        'FechaHasta': this.getFechaHasta(),
        'ClientesId': [this.$store.state.user.cliente.Id],
        'Estado': 98,
        'Pagina': 1,
        'PedidosXPagina': 100
        }
        axios.post('/WebSalesPedidosListado', this.pedidoRequest ,{
          headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                  }
        }).then((response) => {
          if (response.data.Code == 0)
          {
            var pedidos = []
            var presupuestos = []
            var devoluciones = []
            var i = 0 

            if ((response.data.Pedidos) && (response.data.Pedidos.length > 0)) {

                var completo = false 
                while ((i < response.data.Pedidos.length) && (!completo)) {
                    if ((response.data.Pedidos[i].Tipo == 1) && (pedidos.length < 2)) {
                        pedidos.push(response.data.Pedidos[i])
                    }
                    else if ((response.data.Pedidos[i].Tipo == 2)  && (presupuestos.length < 2))  {
                        presupuestos.push(response.data.Pedidos[i])
                    }
                    else if ((response.data.Pedidos[i].Tipo == 3)  && (devoluciones.length < 2))  {
                        devoluciones.push(response.data.Pedidos[i])
                    }

                    if ((pedidos.length >= 2) &&(presupuestos.length >= 2) &&(devoluciones.length >= 2)) {
                      completo = true    
                    }
                    i++ 
                }
                this.$store.commit('pedido/savePedidosHome',pedidos)
                this.$store.commit('pedido/savePresupuestosHome',presupuestos)
                this.$store.commit('pedido/saveDevolucionesHome',devoluciones)
            }
          }
          else {
            var obj = {
                    txt:response.data.Message,
                    txtBtnCancel:'',
                    txtBtnOk:'Aceptar',
                    fCancel:null,
                    fOk:null
                }
            this.$store.commit('popup/open',obj);
          }
         this.getCtaCte();
        }).catch((error) => {
            alert(error)
        });
      },


    getCtaCte() {
          axios
            .get("/WebSalesCtaCte?ClienteId=" + this.$store.state.user.cliente.Id, {
              headers: {
                Token:        this.$store.state.user.usuario.Token,
                ClientSecret: this.$store.state.entorno.clientSecret,
                EmpresaId:    this.$store.state.entorno.idEmpresa
              }
            })
            .then(
              response => {
                this.$store.commit("loader/stop");
                if (response.data.Code == 0) 
                {
                  this.items = response.data.Comprobantes
                  //console.log(response.data.Comprobantes)
                  this.$store.commit("user/saveCtaCte", response.data);
                }
              },
              error => {
                this.$store.commit('loader/stop')
                this.$access("any");
                alert(response.data.Message)
                this.$store.commit('user/deleteUser');
                this.$store.commit('user/deleteCliente');
                this.$store.commit('user/deleteEmpresas');
                this.$store.commit('user/deleteResponseLogin');
                this.$store.commit('user/deleteImagenLogo'); 
                this.$store.commit("pedido/delete");
                this.$router.push({name: 'login'});        
              }
            );
    },



    filtrarDescuentos(d) {
        var descuentos = []
        d.forEach((desc) => { 

            if ((!desc.AsignaPorCliente) && 
                (!desc.AsignaPorCadena) && 
                (!desc.AsignaPorListaDePrecio) && 
                (!desc.AsignaPorLocalidad) && 
                (!desc.AsignaPorAgrupacionAdicional1) &&                             
                (!desc.AsignaPorAgrupacionAdicional2) && 
                (!desc.AsignaPorSectorGeografico) && 
                (desc.EtiquetasCliente == null))  {
                descuentos.push(desc)                 
            }
            else {
                var asignarDescuento = true

                var encontrado = false
                if ((desc.AsignaPorCliente) && (desc.Clientes)) {
                    desc.Clientes.every((cli) => {  
                        if (cli.Id == this.$store.state.user.cliente.Id) {
                            encontrado = true
                            return false    
                        }     
                        return true
                    })
                    if (!encontrado) {
                        asignarDescuento = false
                    }
                }

                // se llama agrupacion en servicio clientes detalle 
                encontrado = false
                if ((desc.asignaPorCadena) && (desc.Cadenas)) {
                    desc.Cadenas.every((agrup) => {  
                        this.$store.state.user.cliente.Agrupaciones.every((agrupCli) => {
                            if (agrup.Id == agrupCli.Id) {
                                encontrado = true
                                return false    
                            }     
                            return true
                        })
                        return true
                    })
                    if (!encontrado) {
                        asignarDescuento = false
                    }
                }

                if ((desc.asignaPorLocalidad) && (desc.ValorLocalidad)) {
                    if (desc.ValorLocalidad != this.$store.state.user.cliente.Localidad) {
                        asignarDescuento = false
                    }
                }
                
                encontrado = false
                if ((desc.asignaPorListaDePrecio) && (desc.ListaPrecios)) {
                    desc.ListaPrecios.every((lista) => {  
                        if (lista.Id == this.$store.state.user.cliente.ListaPrecioId) {
                            encontrado = true
                            return false    
                        }     
                        return true
                    })
                    if (!encontrado) {
                        asignarDescuento = false
                    }
                }

                encontrado = false
                if ((desc.asignaPorAgrupacionAdicional1) && (desc.AgrupacionAdicional1) && (this.$store.state.user.cliente.AgrupacionAdicional1Id)) {
                    desc.AgrupacionAdicional1.every((agrup) => {  
                        this.$store.state.user.cliente.AgrupacionAdicional1Id.every((agrupCli) => {
                            if (agrup.Id == agrupCli) {
                                encontrado = true
                                return false    
                            }     
                            return true
                        })
                        return true
                    })
                    if (!encontrado) {
                        asignarDescuento = false
                    }
                }

                encontrado = false
                if ((desc.asignaPorAgrupacionAdicional2) && (desc.AgrupacionAdicional2) && (this.$store.state.user.cliente.AgrupacionAdicional2Id)) {
                    desc.AgrupacionAdicional2.every((agrup) => {  
                        this.$store.state.user.cliente.AgrupacionAdicional2Id.every((agrupCli) => {
                            if (agrup.Id == agrupCli) {
                                encontrado = true
                                return false    
                            }     
                            return true
                        })
                        return true
                    })
                    if (!encontrado) {
                        asignarDescuento = false
                    }
                }
          
                encontrado = false
                if ((desc.asignaPorSectorGeografico) && (desc.SectorGeografico) && (this.$store.state.user.cliente.SectorGeograficoId)) {
                    desc.SectorGeografico.every((sector) => {  
                        this.$store.state.user.cliente.SectorGeograficoId.every((sectorCli) => {
                            if (sector.Id == sectorCli) {
                                encontrado = true
                                return false    
                            }     
                            return true
                        })
                        return true
                    })
                    if (!encontrado) {
                        asignarDescuento = false
                    }
                }

                encontrado = false
                if (desc.EtiquetasCliente) {
                    if (this.$store.state.user.cliente.EtiquetasDescuento) {
                        var etiquetasCli = this.$store.state.user.cliente.EtiquetasDescuento.split(',')
                        desc.EtiquetasCliente.every((etiqueta) => {  
                            etiquetasCli.every((etiquetaCli) => {
                                if (etiqueta == etiquetaCli) {
                                    encontrado = true
                                    return false    
                                }     
                                return true
                            })
                            return true
                        })
                    }
                    if (!encontrado) {
                        asignarDescuento = false
                    }
                }

            }

            if (asignarDescuento) {
                descuentos.push(desc)
            }

        })  

        // console.log('<Descuentos>')
        // console.log(descuentos)
        this.$store.commit('pedido/saveDescuentos',descuentos)
    },



    // filtrarDescuentos(d) {
    //     var descuentos = []
    //     d.forEach((desc) => { 
    //         if (!desc.AsignaPorCliente) {
    //           descuentos.push(desc)
    //         }
    //         else {
    //             if (desc.Clientes) {
    //                 desc.Clientes.every((cli) => {  
    //                     if (cli.Id == this.$store.state.user.cliente.Id) {
    //                         descuentos.push(desc)
    //                         return false    
    //                     }     
    //                     return true
    //                 })
    //             }
    //         }
    //     })  
    //   this.$store.commit('pedido/saveDescuentos',descuentos)
    // },


      btnCtaCte() {
        this.$router.push({ name: 'ctacte' });
      },

   
      btnNuevoPedido() {
        if (this.$store.state.pedido.carrito.length > 0) {
            if (this.$store.state.pedido.tipoOperacion == 'pedido') {
                this.$store.commit('pedido/setBorradorId',0);
                this.$router.push({ name: 'realizarPedidoCat' });
            }
            else if (this.$store.state.pedido.tipoOperacion == 'presupuesto') {
                var obj = {
                      txt:'Existe un nuevo presupuesto en curso, si crea un nuevo pedido se perderan los productos cargados en el presupuesto',
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
                this.$store.commit('popup/open',obj);
            }
            else if (this.$store.state.pedido.tipoOperacion == 'devolucion') {
                var obj = {
                      txt:'Existe una nueva devolucion en curso, si crea un nuevo pedido se perderan los productos cargados en la devolucion',
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
                this.$store.commit('popup/open',obj);
            }
        }
        else {
            this.$store.commit('pedido/saveTipoOperacion','pedido');
            this.$store.commit('pedido/setBorradorId',0);
            this.$router.push({ name: 'realizarPedidoCat' });
        }
      },


      btnNuevoPresupuesto() {
        if (this.$store.state.pedido.carrito.length > 0) {
            if (this.$store.state.pedido.tipoOperacion == 'presupuesto') {
                this.$store.commit('pedido/setBorradorId',0);
                this.$router.push({ name: 'realizarPresupuestoCat' });
            }
            else if (this.$store.state.pedido.tipoOperacion == 'pedido') {
                var obj = {
                      txt:'Existe un nuevo pedido en curso, si crea un nuevo presupuesto se perderan los productos cargados en el pedido',
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
                this.$store.commit('popup/open',obj);
            }
            else if (this.$store.state.pedido.tipoOperacion == 'devolucion') {
                var obj = {
                      txt:'Existe una nueva devolucion en curso, si crea un nuevo presupuesto se perderan los productos cargados en la devolucion',
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
                this.$store.commit('popup/open',obj);
            }
        }
        else {
            this.$store.commit('pedido/saveTipoOperacion','presupuesto');
            this.$store.commit('pedido/setBorradorId',0);
            this.$router.push({ name: 'realizarPresupuestoCat' });
        }
      },



      btnNuevaDevolucion() {
        if (this.$store.state.pedido.carrito.length > 0) {
            if (this.$store.state.pedido.tipoOperacion == 'devolucion') {
                this.$store.commit('pedido/setBorradorId',0);
                this.$router.push({name: 'realizarDevolucionCat'});
            }
            else if (this.$store.state.pedido.tipoOperacion == 'presupuesto') {
                var obj = {
                      txt:'Existe un nuevo presupuesto en curso, si crea una nueva devolucion se perderan los productos cargados en el presupuesto',
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
                this.$store.commit('popup/open',obj);
            }
            else if (this.$store.state.pedido.tipoOperacion == 'pedido') {
                var obj = {
                      txt:'Existe un nuevo pedido en curso, si crea una nueva devolucion se perderan los productos cargados en el pedido',
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
                this.$store.commit('popup/open',obj);
            }
        }
        else {
            this.$store.commit('pedido/saveTipoOperacion','devolucion');
            this.$store.commit('pedido/setBorradorId',0);
            this.$router.push({ name: 'realizarDevolucionCat' });
        }
      },



      btnVerPromociones() {
        this.$router.push({ name: 'promociones' });
      },

      btnVerDescuentos() {
         this.$router.push({ name: 'descuentos' });
      },

      btnVerEstadoPedidos() {
        this.$router.push({ name: 'estadoPedido' });
      },

      btnVerDevoluciones() {
        this.$router.push({name: 'estadoDevolucion'});
      },

      btnVerPresupuestos() {
        this.$router.push({ name: 'estadoPresupuesto' });
      },


      getFechaHasta(){
        //'Fecha': "dd/mm/yyyy",  --> 1 dia mas que fecha actual
        var date   =  new Date();
        date.setMilliseconds(date.getMilliseconds()+86400000)
        var dia    =  ''
        var mes    =  ''
        if (date.getDate()<10)
        {
          dia = '0'+ date.getDate().toString()
        }
        else
        {
          dia = date.getDate().toString()
        }

        if ((date.getMonth() + 1)<10)
        {
          mes = '0'+ (date.getMonth()+1).toString()
        }
        else
        {
          mes = (date.getMonth()+1).toString()
        }
        return  dia+'/'+mes+'/'+date.getFullYear();
     },
  },

  mounted() {
    this.$store.commit('loader/stop')
    // console.log('<<<3>>>') 
    // console.log(this.$store.state.user.usuario) 
    this.onResize()
    localStorage.setItem("lastActivity",Math.floor(Date.now() / 1000));
    if ((this.$store.state.pedido.productos.length == 0) || (this.$store.state.entorno.reload))
    {
      this.$store.commit("entorno/reload",false);
      this.getPromociones();
    }
  },

  created() {
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }

}


</script>

<style scoped>


 #promoDescLabelContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }


 #promoDescContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }


 #headerImageContainer {
    width: 100%;
    height: 26vh;
    background: linear-gradient(#005A9F , #1899D6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

 #headerImage {
    height: 120px;
  }

 #mainContainer {
 position: absolute;
 top: 65%;
 left: 50%;
 transform: translate(-50%,-50%);
 width: 700px;
 height: 59vh;
 box-sizing: border-box;
 background-color: #ffffff;
 display: flex;
 overflow: auto;
 flex-direction: column;
 align-items: flex-start;
}

.verTodos{
  font-size: 11px;
  color: #4969B2;
  font-weight: bold;
  margin-left: 5px;
}

.verTodos:hover { cursor: pointer; }


.tituloSeccion{
  font-size: 16px;
  color: black;
  font-weight: 500;
  margin-bottom: 5px;
}


#labelCtaCte{
  font-size: 18px;
  color: red;
  font-weight: 500;
  margin-left: 10px;
  margin-bottom: 5px;
}


#promoContainer {
 display: flex;
 flex-direction:row ;
}


#descContainer {
 width: 200px;
 height: 150px;
 background: #ffffff;
 display: flex;
 flex-direction:column ;
}


#labelEstado {
  margin-top: 30px;
}





.oblea{
    width: 190px;
    height: 120px;
    border-width: 1px;
    border: 1px solid #dddddd;
    background: #ffffff;
    margin-right: 20px;
    display: flex;
    flex-direction:column;
    align-items: center;
    justify-content: center;
    box-shadow: 2px 2px 4px #dddddd;  
    -webkit-box-shadow: 2px 2px 4px #dddddd;  
    -moz-box-shadow:    2px 2px 4px #dddddd;  
  }



.oblea-NuevoPedido{
    width: 190px;
    height: 120px;
    border-width: 1px;
    border: 1px dashed #dddddd;
    background: #ffffff;
    margin-right: 20px;
    display: flex;
    flex-direction:column;
    align-items: center;
    justify-content: center;
  }

.oblea:hover{
    cursor: pointer;
    background: #f9f9f9;
  }


.oblea-NuevoPedido:hover{
    cursor: pointer;
    background: #f9f9f9;
  }


#label-realizarPedido{
    margin-top: 5px;
    font-size: 10px;
}



 fh.lc.mobile::-webkit-scrollbar {
     display: none;
  }



 /* width */
  ::-webkit-scrollbar {
      width: 5px;
      height: 0px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd; 
      border-radius: 10px;
  }
  
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb; 
      border-radius: 10px;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc; 
  }
  
  
  ::-webkit-scrollbar { 
  display: block; }
 




</style>



// WEBPACK FOOTER //
// src/components/views/home/home.vue